/**
 * ** Ilirija Biograd **
 *
 * @exports partnership_10033
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
        * @memberOf module:partnership_10033
        */
    partnership.getId = function getId() {
        return '10033';
    };
    /**
        * @memberOf module:partnership_10033
        */
    partnership.check = function check() {
        const hostname = window.location.hostname;
        return hostname.match(/ilirijabiograd/);
    };
    /**
        * @memberOf module:partnership_10033
        */
    partnership.getSiteId = function getSiteId() {
        let result;
        const isBookingEngine = !!window.location.pathname.match(/booking/);
        const isCorpoPage = !!window.location.pathname.match(/hoteli-i-vile|hotels-und-villen|hotel-e-ville|hoteli-in-vile|hotels-and-villas/);
        const hotelIdBookingEngineUrl = isBookingEngine && document.querySelector('[class*=Topbar] a')?.href;
        const hotelIdAfterRoomsAndRates = hotelIdBookingEngineUrl && new URL(hotelIdBookingEngineUrl)?.pathname?.split('/')?.pop();
        const hotelIdHomeUrl = !isBookingEngine && document.querySelector('[class*=AccommodationCard_detailsBox]')?.href;
        const hotelIdHome = hotelIdHomeUrl && new URLSearchParams(new URL(hotelIdHomeUrl)?.search)?.get('hotel');
        const hotelId = thn.parseUrlParameter('hotel') || hotelIdAfterRoomsAndRates || hotelIdHome;
        const isValidHotelId = hotelId !== 'parcels';
        if (hotelId && isValidHotelId && !isCorpoPage) {
            result = {
                externalId: hotelId,
            };
        }
        else {
            result = {
                accountKey: 'B56FCF9008ECA57A2DE01B1B0D19D4AF',
            };
        }
        return result;
    };
    /**
   * @memberOf module:partnership_10033
   */
    partnership.boot = function boot() {
        if (!window.dataLayer) {
            return;
        }
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 500);
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event?.match(/gtm.historyChange-v2/)) {
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    return partnership;
}

export { factory };
